import "./RescheduleList.scss"
import React, { useEffect, useState } from 'react'
import { Button, Dialog, DialogContent, DialogContentText, FormControl, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { axiosInstance } from '../../Services/Interceptor/Interceptor';
import API_END_POINTS from '../../Utilities/Constants/ApiEndpoints';
import { t } from 'i18next';
import * as Yup from 'yup';
import { Formik, Form, ErrorMessage } from 'formik';
import moment from "moment";
import { COMMON_CONSTANTS, NUMBER_CONSTANTS, STORAGE_KEYS } from "../../Utilities/Constants/Constants";
import { GetSessionStorageData } from "../../Services/Helpers/Helper";
interface RescheduleListProps {
    modalOpen: any;
    handleClose: () => void;
    handleSubmit: (value: any, values: any) => void;
}
const RescheduleList: React.FC<RescheduleListProps> = ({ modalOpen, handleClose, handleSubmit }) => {
    const [list, setList] = useState<any>([])
    const [sessionId, setSesssionId] = useState<any>({ session_id: "", sessionSlotId: "", id: "" })
    const [roleId, setRoleId] = useState("");

    useEffect(() => {
        moment.locale('en')
        setRoleId(GetSessionStorageData(STORAGE_KEYS.ROLE) || "");
    }, []);

    const [initialValues, setInitialValues] = useState({
        title: "",
        startDate: "",
        endTime: "",
        startTime: "",
    });

    useEffect(() => {
        if (modalOpen?.session_id) { // Check if title exists
            const payload = {
                session_id: modalOpen.session_id,
                start_time: modalOpen?.startTime,
                end_time: modalOpen?.endTime
            };
            const rescheduleApi = roleId === `${NUMBER_CONSTANTS.NINE}` ? API_END_POINTS.PT_RECHEDUL_LIST : API_END_POINTS.RESCHEDULE_LIST
            axiosInstance
                .get(rescheduleApi, { params: payload })
                .then((response: any) => {
                    if (response.status) {
                        // Handle successful response here
                        setList(response?.data?.result?.data)
                        setSesssionId({ session_id: response?.data?.result?.data[0].available_slots[0]?.session_id, sessionSlotId: "", id: "" })
                        setInitialValues((prevValues) => ({
                            ...prevValues, // Preserve other values in initialValues
                            title: response?.data?.result?.data[0].available_slots[0]?.title || "",
                            endTime: response?.data?.result?.data[0].available_slots[0]?.end_time || "",
                            startTime: response?.data?.result?.data[0].available_slots[0]?.start_time || ""
                        }));
                    }
                })
                .catch((error) => {
                    console.error("Error fetching reschedule list:", error);
                });
        }
    }, [modalOpen?.session_id]);

    let validatedSchema = Yup.object().shape({
        title: Yup.string(),
        startDate: Yup.string().required("EndTime is required"),
        endTime: Yup.string(),
        startTime: Yup.string(),
    })
    return (

        <div >
            <Dialog open={modalOpen?.state} sx={{ '& .MuiDialog-paper': { maxWidth: '70%' } }}>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <Formik
                            initialValues={initialValues}
                            validationSchema={validatedSchema}
                            onSubmit={(value: any) => {
                                handleSubmit(value, sessionId)
                            }}
                            enableReinitialize={true}>

                            {({ values, handleChange, setFieldValue }) => (
                                <Form>
                                    <div className='select_container'>
                                        <div className='formControllers'>
                                            <FormControl sx={{ m: 1, minWidth: 200 }} disabled>
                                                <label style={{ textAlign: "center" }}>Title</label>
                                                <Select
                                                    name="title"
                                                    value={values?.title}
                                                    labelId="demo-select-small-label"
                                                    id="demo-select-small"
                                                    onChange={(event) => {
                                                        setFieldValue("title", event.target.value);
                                                    }}
                                                    className='selectfield'
                                                >
                                                    <MenuItem key={list[0]?.available_slots[0]?.title} value={list[0]?.available_slots[0]?.title}>
                                                        {list[0]?.available_slots[0]?.title}
                                                    </MenuItem>

                                                </Select>

                                            </FormControl>

                                        </div>
                                        <div className='formControllers'>
                                            <FormControl sx={{ m: 1, minWidth: 200 }}>
                                                <label style={{ textAlign: "center" }}>Start Date</label>
                                                <Select
                                                    name="startDate"
                                                    value={values?.startDate || ""}
                                                    onChange={(event) => {
                                                        const selectedDate: any = event.target.value;
                                                        setFieldValue("startDate", selectedDate);

                                                        const sessionSlot = list[0]?.available_slots.find(
                                                            (res: any) => res.start === selectedDate
                                                        );
                                                        if (sessionSlot) {
                                                            setSesssionId({
                                                                session_id: sessionSlot?.session_id,
                                                                sessionSlotId: sessionSlot?.session_slot,
                                                                id: sessionSlot?.id,
                                                            });
                                                        }
                                                    }}
                                                    MenuProps={{
                                                        PaperProps: {
                                                            style: {
                                                                maxHeight: 300,
                                                                marginTop: 10,
                                                            },
                                                        },
                                                    }}
                                                    className="selectfield"
                                                >
                                                    {list[0]?.available_slots?.map((res: any) => (
                                                        <MenuItem key={res.start} value={res.start}>
                                                            {moment(res.start).format(COMMON_CONSTANTS.YMD_FORMAT)}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                <ErrorMessage name="startDate" className="err-msg" component="div" />
                                            </FormControl>

                                        </div>
                                        <div className='formControllers'>
                                            <FormControl sx={{ m: 1, minWidth: 200 }} disabled>
                                                <label style={{ textAlign: "center" }}>
                                                    startTime</label>
                                                <Select
                                                    name="startTime"
                                                    value={values?.startTime}
                                                    labelId="demo-select-small-label"
                                                    id="demo-select-small"
                                                    onChange={(event: any) => {
                                                        setFieldValue("startTime", event.target.value);
                                                    }}
                                                    MenuProps={{
                                                        PaperProps: {
                                                            style: {
                                                                maxHeight: 300,
                                                                marginTop: 10
                                                            },
                                                        },
                                                    }}
                                                    className='selectfield'
                                                >
                                                    {list[0]?.available_slots?.map((res: any) => (
                                                        <MenuItem key={res?.start_time} value={res?.start_time}>
                                                            {res?.start_time}
                                                        </MenuItem>
                                                    ))}
                                                </Select>

                                            </FormControl>
                                        </div>
                                        <div className='formControllers'>
                                            <FormControl sx={{ m: 1, minWidth: 200 }} disabled>
                                                <label style={{ textAlign: "center" }}>
                                                    EndTime</label>
                                                <Select
                                                    name="endtime"
                                                    value={values?.endTime}
                                                    labelId="demo-select-small-label"
                                                    id="demo-select-small"

                                                    onChange={(event) => {
                                                        setFieldValue("endTime", event.target.value);
                                                    }}
                                                    MenuProps={{
                                                        PaperProps: {
                                                            style: {
                                                                maxHeight: 300,
                                                                marginTop: 10
                                                            },
                                                        },
                                                    }}
                                                    className='selectfield'
                                                >
                                                    {list[0]?.available_slots?.map((res: any) => (
                                                        <MenuItem key={list[0]?.available_slots[0].end_time} value={list[0]?.available_slots[0].end_time}>
                                                            {list[0]?.available_slots[0].end_time}
                                                        </MenuItem>
                                                    ))}
                                                </Select>

                                            </FormControl>
                                        </div>
                                    </div >
                                    <div className="btn-field">
                                        <Button onClick={handleClose} className="no-btn">{t("Cancel")}</Button>
                                        <Button className="yes-btn" type="submit">{t("Submit")}</Button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        </div>

    )
}

export default RescheduleList
